export const setCookie = (name: string, value: object, days: number): void => {
  const expires = new Date(
    Date.now() + days * 24 * 60 * 60 * 1000,
  ).toUTCString();
  const stringValue = encodeURIComponent(JSON.stringify(value));
  document.cookie = `${name}=${stringValue}; expires=${expires}; path=/`;
};

// Get a cookie by name and parse it as JSON
export const getCookie = (name: string): Record<string, any> | null => {
  const nameEQ = `${name}=`;
  const cookiesArray = document.cookie.split(';');
  for (let cookie of cookiesArray) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      try {
        return JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length)));
      } catch (error) {
        console.error('Error parsing cookie:', error);
      }
    }
  }
  return null;
};
